module.exports = __webpack_public_path__ + "static/media/telethon.593ef0c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeDo/telethon.png
// module id = 389
// module chunks = 0